/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MoreInfoComponent as ɵd} from './lib/components/more-info/more-info.component';
export {QuestionsAndAnswersComponent as ɵc} from './lib/components/questions-and-answers/questions-and-answers.component';
export {MagazineArticlePipe as ɵb} from './lib/pipes/magazine-article.pipe';
export {MagazineCategoryPipe as ɵa} from './lib/pipes/magazine-category.pipe';